import { makeRequest } from "src/api/request";

export const getDashboardData = async () => await makeRequest.get<API.Dashboard.getDashboardData.Response>(`/dashboard/`);

export const getMariaPackage = async () => await makeRequest.get<API.Dashboard.getDashboardPackageData.Response>(`/dashboard/maria-package/`);

export const getScoutPackage = async () => await makeRequest.get<API.Dashboard.getDashboardPackageData.Response>(`/dashboard/scout-package/`);

export const getMariaProPackage = async () =>
  await makeRequest.get<API.Dashboard.getDashboardPackageData.Response>(`/dashboard/maria-pro-package/`);
